import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=b650c952&scoped=true&"
import script from "./ItemView.vue?vue&type=script&lang=js&"
export * from "./ItemView.vue?vue&type=script&lang=js&"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=b650c952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b650c952",
  null
  
)

export default component.exports